var _style, _g, _circle, _path, _circle2, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 133.8 254.6",
    style: {
      enableBackground: "new 0 0 133.8 254.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.4,3.1c1.2,0,2.1,0.9,2.1,2.1V85c0,1.2-0.9,2.1-2.1,2.1H5.3c-1.2,0-2.1-0.9-2.1-2.1V5.1 C3.2,3.9,4.1,3,5.3,3L41.4,3.1 M41.4,0.1H5.3c-2.8,0-5.1,2.3-5.1,5.1V85c0,2.8,2.3,5.1,5.1,5.1h36.1c2.8,0,5.1-2.3,5.1-5.1V5.1 C46.5,2.3,44.2,0.1,41.4,0.1L41.4,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.5,2c0,2.8,1.9,5.1,4.1,5.1H32c2.3,0,4.1-2.3,4.1-5.1C36.2,2,10.5,2,10.5,2z M26.2,4.6h-9.5 c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h9.5c0.3,0,0.5,0.2,0.5,0.5S26.5,4.6,26.2,4.6z M29.3,4.7c-0.4,0-0.7-0.3-0.7-0.7 s0.3-0.7,0.7-0.7S30,3.6,30,4S29.6,4.7,29.3,4.7z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 35.1,
    cy: 87.9,
    r: 13.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.1,88.1c14,0.3,52.4,0.1,52.4,0.1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 34.1,
    cy: 145.7,
    r: 13.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.1,99.1c14,0.3,31.1,0.1,31.1,0.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.4,110.4c23,0.1,86.1,0,86.1,0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.1,135.6c14,0.3,52.4,0.1,52.4,0.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.1,147.6c14,0.3,31.1,0.1,31.1,0.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.1,158.6c8.1,0.3,30.4,0.1,30.4,0.1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.c23de54c770babc7aab562fee9195344.svg";
export { ForwardRef as ReactComponent };